import { APInvoiceStatus, PaymentStatus } from '@erp/shared-types';

export function canMarkInvoicePaid(invoice: {
  status: string;
  paymentStatus: string | null | undefined;
}): boolean {
  if (
    invoice.status === APInvoiceStatus.VOID ||
    invoice.status === APInvoiceStatus.IGNORED
  ) {
    return false;
  }
  if (
    invoice.paymentStatus === PaymentStatus.PAID ||
    invoice.paymentStatus === PaymentStatus.OVERPAID
  ) {
    return false;
  }
  return true;
}
